import { get } from 'lodash';
import React from 'react';
import { TreeNodeType } from 'src/lib/types/types';
import { isTrue } from 'src/utils/helper';
import { checkIfZeitplaungHasComment } from '../../../application-helper-function/PruefAssistenzHelperFunktion';
import ZeitplanungGlobal, { getFormStrucZeitplanungGlobal } from './content/ZeitplanungGlobal';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

export const TreeStructureZeitplanungGlobal = (application: any, readOnly: boolean) => {
	const hasCommentZeitplanung = checkIfZeitplaungHasComment(readOnly, application);
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Zeitplanung',
			content: <ZeitplanungGlobal hasComment={hasCommentZeitplanung} />,
			formStruc: getFormStrucZeitplanungGlobal(application),
			hasComment: hasCommentZeitplanung,
		},
	];

	if (isTrue(get(application, P.Foerderprogramm.schema.attributes.Konfiguration_Zeitplanung_Erforderlich.path))) {
		return treeNodes;
	}

	return [];
};
